<template>
  <div class="flex flex-wrap">
    <div class="w-full mt-12 mb-12 px-4">
      <BasicEditPage
        v-if="isBasicComp && getOperationMode === 'update'"
        :componentId="compId"
        :instanceId="instanceId"
      />
      <BasicCreatePage
        v-if="isBasicComp && getOperationMode === 'create'"
        :componentId="compId"
      />
      <!-- abi_category_faq -->
      <DNComponentCreatePage
        v-if="
          getComponentId('abi_category_faq') === compId &&
          getOperationMode === 'create'
        "
        :elementName="'faq'"
        :componentId="compId"
        :attributesCategory="faqCategory"
      />
      <DNComponentUpdatePage
        v-if="
          getComponentId('abi_category_faq') === compId &&
          getOperationMode === 'update'
        "
        :elementName="'faq'"
        :componentId="compId"
        :attributesCategory="faqCategory"
        :instanceId="instanceId"
      />
      <!-- abi_content_block_wrapper -->
      <DNComponentCreatePage
        v-if="
          getComponentId('abi_content_block_wrapper') === compId &&
          getOperationMode === 'create'
        "
        :elementName="'wrapper'"
        :componentId="compId"
        :attributesCategory="wrapperCategory"
      />
      <DNComponentUpdatePage
        v-if="
          getComponentId('abi_content_block_wrapper') === compId &&
          getOperationMode === 'update'
        "
        :elementName="'wrapper'"
        :componentId="compId"
        :attributesCategory="wrapperCategory"
        :instanceId="instanceId"
      />
      <!-- abi_grid -->
      <DNComponentCreatePage
        v-if="
          getComponentId('abi_grid') === compId && getOperationMode === 'create'
        "
        :elementName="'grid'"
        :componentId="compId"
        :attributesCategory="gridCategory"
      />
      <DNComponentUpdatePage
        v-if="
          getComponentId('abi_grid') === compId && getOperationMode === 'update'
        "
        :elementName="'grid'"
        :componentId="compId"
        :attributesCategory="gridCategory"
        :instanceId="instanceId"
      />
      <!-- abi_tiles -->
      <DNComponentCreatePage
        v-if="
          getComponentId('abi_tiles') === compId &&
          getOperationMode === 'create'
        "
        :elementName="'tile'"
        :componentId="compId"
        :attributesCategory="tilesCategory"
      />
      <DNComponentUpdatePage
        v-if="
          getComponentId('abi_tiles') === compId &&
          getOperationMode === 'update'
        "
        :elementName="'tile'"
        :componentId="compId"
        :attributesCategory="tilesCategory"
        :instanceId="instanceId"
      />
      <!-- abi_card -->
      <DNComponentCreatePage
        v-if="
          getComponentId('abi_card') === compId && getOperationMode === 'create'
        "
        :elementName="'card'"
        :componentId="compId"
        :attributesCategory="cardCategory"
      />
      <DNComponentUpdatePage
        v-if="
          getComponentId('abi_card') === compId && getOperationMode === 'update'
        "
        :elementName="'card'"
        :componentId="compId"
        :attributesCategory="cardCategory"
        :instanceId="instanceId"
      />
      <!-- abi_hero_review -->
      <DNComponentCreatePage
        v-if="
          getComponentId('abi_hero_review_slider') === compId &&
          getOperationMode === 'create'
        "
        :elementName="'review'"
        :componentId="compId"
        :attributesCategory="heroReviewCategory"
      />
      <DNComponentUpdatePage
        v-if="
          getComponentId('abi_hero_review_slider') === compId &&
          getOperationMode === 'update'
        "
        :elementName="'review'"
        :componentId="compId"
        :attributesCategory="heroReviewCategory"
        :instanceId="instanceId"
      />
      <!-- abi_card_slider -->
      <DNComponentCreatePage
        v-if="
          getComponentId('abi_card_slider') === compId &&
          getOperationMode === 'create'
        "
        :elementName="'slider'"
        :componentId="compId"
        :attributesCategory="cardSliderCategory"
      />
      <DNComponentUpdatePage
        v-if="
          getComponentId('abi_card_slider') === compId &&
          getOperationMode === 'update'
        "
        :elementName="'slider'"
        :componentId="compId"
        :attributesCategory="cardSliderCategory"
        :instanceId="instanceId"
      />
      <!-- abi_instgram_post -->
      <DNComponentCreatePage
        v-if="
          getComponentId('abi_instagram_post') === compId &&
          getOperationMode === 'create'
        "
        :elementName="'post'"
        :componentId="compId"
        :attributesCategory="instagramPostCategory"
      />
      <DNComponentUpdatePage
        v-if="
          getComponentId('abi_instagram_post') === compId &&
          getOperationMode === 'update'
        "
        :elementName="'post'"
        :componentId="compId"
        :attributesCategory="instagramPostCategory"
        :instanceId="instanceId"
      />
      <!-- abi_header_banner_text -->
      <DNComponentCreatePage
        v-if="
          getComponentId('abi_header_banner_text') === compId &&
          getOperationMode === 'create'
        "
        :elementName="'banner'"
        :componentId="compId"
        :attributesCategory="bannerCategory"
      />
      <DNComponentUpdatePage
        v-if="
          getComponentId('abi_header_banner_text') === compId &&
          getOperationMode === 'update'
        "
        :elementName="'banner'"
        :componentId="compId"
        :attributesCategory="bannerCategory"
        :instanceId="instanceId"
      />
      <!-- abi_card_tabs -->
      <DNComponentCreatePage
        v-if="
          getComponentId('abi_card_tab') === compId &&
          getOperationMode === 'create'
        "
        :elementName="'tab'"
        :componentId="compId"
        :attributesCategory="cardTabCategory"
      />
      <DNComponentUpdatePage
        v-if="
          getComponentId('abi_card_tab') === compId &&
          getOperationMode === 'update'
        "
        :elementName="'tab'"
        :componentId="compId"
        :attributesCategory="cardTabCategory"
        :instanceId="instanceId"
      />
      <!-- abi_custom_cards -->
      <DNComponentCreatePage
        v-if="
          getComponentId('abi_custom_cards') === compId &&
          getOperationMode === 'create'
        "
        :elementName="'card'"
        :componentId="compId"
        :attributesCategory="customCardCategory"
      />
      <DNComponentUpdatePage
        v-if="
          getComponentId('abi_custom_cards') === compId &&
          getOperationMode === 'update'
        "
        :elementName="'card'"
        :componentId="compId"
        :attributesCategory="customCardCategory"
        :instanceId="instanceId"
      />
      <!-- abi_lined_icons_text -->
      <DNComponentCreatePage
        v-if="
          getComponentId('abi_lined_icons_text') === compId &&
          getOperationMode === 'create'
        "
        :elementName="'text'"
        :componentId="compId"
        :attributesCategory="linedIconsTextCategory"
      />
      <DNComponentUpdatePage
        v-if="
          getComponentId('abi_lined_icons_text') === compId &&
          getOperationMode === 'update'
        "
        :elementName="'text'"
        :componentId="compId"
        :attributesCategory="linedIconsTextCategory"
        :instanceId="instanceId"
      />
      <!-- abi_header_banner_mobile -->
      <DNComponentCreatePage
        v-if="
          getComponentId('abi_header_banner_mobile') === compId &&
          getOperationMode === 'create'
        "
        :elementName="'banner'"
        :componentId="compId"
        :attributesCategory="bannerMobileCategory"
      />
      <DNComponentUpdatePage
        v-if="
          getComponentId('abi_header_banner_mobile') === compId &&
          getOperationMode === 'update'
        "
        :elementName="'banner'"
        :componentId="compId"
        :attributesCategory="bannerMobileCategory"
        :instanceId="instanceId"
      />
      <!-- abi-content-tabs -->
      <DNComponentCreatePage
        v-if="
          getComponentId('abi_content_tabs') === compId &&
          getOperationMode === 'create'
        "
        :elementName="'tab'"
        :componentId="compId"
        :attributesCategory="tabsCategory"
      />
      <DNComponentUpdatePage
        v-if="
          getComponentId('abi_content_tabs') === compId &&
          getOperationMode === 'update'
        "
        :elementName="'tab'"
        :componentId="compId"
        :attributesCategory="tabsCategory"
        :instanceId="instanceId"
      />
      <!-- abi-content-block-with-summary -->
      <SDNComponentCreatePage
        v-if="
          getComponentId('abi_content_block_w_summary') === compId &&
          getOperationMode === 'create'
        "
        :elementName="'block'"
        :componentId="compId"
        :attributesCategory="blocksWithSummaryCategory"
      />
      <SDNComponentUpdatePage
        v-if="
          getComponentId('abi_content_block_w_summary') === compId &&
          getOperationMode === 'update'
        "
        :elementName="'block'"
        :componentId="compId"
        :attributesCategory="blocksWithSummaryCategory"
        :instanceId="instanceId"
      />
      <!-- abi-coloured-block -->
      <SDNComponentCreatePage
        v-if="
          getComponentId('abi_coloured_block') === compId &&
          getOperationMode === 'create'
        "
        :elementName="'block'"
        :componentId="compId"
        :attributesCategory="colouredBlocksCategory"
      />
      <SDNComponentUpdatePage
        v-if="
          getComponentId('abi_coloured_block') === compId &&
          getOperationMode === 'update'
        "
        :elementName="'block'"
        :componentId="compId"
        :attributesCategory="colouredBlocksCategory"
        :instanceId="instanceId"
      />
      <!-- abi-image-slide -->
      <ImageSlideCreatePage
        v-if="
          getComponentId('abi_image_slide') === compId &&
          getOperationMode === 'create'
        "
        :componentId="compId"
      />
      <ImageSlideUpdatePage
        v-if="
          getComponentId('abi_image_slide') === compId &&
          getOperationMode === 'update'
        "
        :componentId="compId"
        :instanceId="instanceId"
      />
      <ImageSliderCreatePage
        v-if="
          getComponentId('abi_image_slider') === compId &&
          getOperationMode === 'create'
        "
        :componentId="compId"
      />
      <ImageSliderUpdatePage
        v-if="
          getComponentId('abi_image_slider') === compId &&
          getOperationMode === 'update'
        "
        :componentId="compId"
        :instanceId="instanceId"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Constants from "@/store/constants";
import * as Actions from "@/store/actions.type";
import ImageSlideCreatePage from "@/components/ComponentModule/ImageSlideComponent/ImageSlideCreatePage";
import ImageSlideUpdatePage from "@/components/ComponentModule/ImageSlideComponent/ImageSlideUpdatePage";
import ImageSliderCreatePage from "@/components/ComponentModule/ImageSliderComponent/ImageSliderCreatePage";
import ImageSliderUpdatePage from "@/components/ComponentModule/ImageSliderComponent/ImageSliderUpdatePage";
import DNComponentCreatePage from "@/components/ComponentModule/DynamicNumComponent/DNComponentCreatePage";
import DNComponentUpdatePage from "@/components/ComponentModule/DynamicNumComponent/DNComponentUpdatePage";
import SDNComponentCreatePage from "@/components/ComponentModule/SpecialDynamicNumComponent/SDNComponentCreatePage";
import SDNComponentUpdatePage from "@/components/ComponentModule/SpecialDynamicNumComponent/SDNComponentUpdatePage";
import BasicEditPage from "@/components/ComponentModule/BasicComponent/BasicEditPage";
import BasicCreatePage from "@/components/ComponentModule/BasicComponent/BasicCreatePage";

export default {
  components: {
    BasicEditPage,
    BasicCreatePage,
    ImageSlideCreatePage,
    ImageSlideUpdatePage,
    ImageSliderCreatePage,
    ImageSliderUpdatePage,
    DNComponentCreatePage,
    DNComponentUpdatePage,
    SDNComponentCreatePage,
    SDNComponentUpdatePage
  },
  props: {
    compId: {
      type: String,
      required: true
    },
    instanceId: {
      type: String,
      required: false
    }
  },
  created() {
    // check tamper monkey region parameter
    if (this.$route.query.region) {
      this.$store.dispatch(Actions.SET_REGION, this.$route.query.region);
    }
  },
  mounted() {
    this.checkOperationMode();
  },
  watch: {
    currentRoute() {
      this.checkOperationMode();
    }
  },
  computed: {
    currentRoute() {
      return this.$router.currentRoute.value.fullPath;
    },
    faqCategory() {
      return Constants.FAQ_ATTRIBUTES;
    },
    wrapperCategory() {
      return Constants.WRAPPER_ATTRIBUTES;
    },
    tilesCategory() {
      return Constants.TILES_ATTRIBUTES;
    },
    gridCategory() {
      return Constants.GRID_ATTRIBUTES;
    },
    tabsCategory() {
      return Constants.TABS_ATTRIBUTES;
    },
    cardCategory() {
      return Constants.CARD_ATTRIBUTES;
    },
    blocksCategory() {
      return Constants.BLOCKS_ATTRIBUTES;
    },
    blocksWithSummaryCategory() {
      return Constants.BLOCKS_WITH_SUMMARY_ATTRIBUTES;
    },
    colouredBlocksCategory() {
      return Constants.COLOURED_BLOCKS_ATTRIBUTES;
    },
    heroReviewCategory() {
      return Constants.HERO_REVIEW_ATTRIBUTES;
    },
    cardSliderCategory() {
      return Constants.CARD_SLIDER_ATTRIBUTES;
    },
    bannerCategory() {
      return Constants.BANNER_ATTRIBUTES;
    },
    bannerMobileCategory() {
      return Constants.BANNER_MOBILE_ATTRIBUTES;
    },
    instagramPostCategory() {
      return Constants.INSTAGRAM_POST_ATTRIBUTES;
    },
    cardTabCategory() {
      return Constants.CARD_TABS_ATTRIBUTES;
    },
    linedIconsTextCategory() {
      return Constants.LINED_ICONS_TEXT_ATTRIBUTES;
    },
    customCardCategory() {
      return Constants.CUSTOM_CARDS_ATTRIBUTES;
    },
    isBasicComp() {
      if (this.getAllComponent.length) {
        let componentName = this.getAllComponent.find(
          (item) => item.id === this.compId
        );
        if (
          Constants.SPECIAL_COMPONENTS.map((item) => item.name).includes(
            componentName.name
          )
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    ...mapGetters(["getOperationMode", "getAllComponent"])
  },
  methods: {
    getComponentId(name) {
      const foundItem = this.getAllComponent.find((item) => item.name === name);
      if (foundItem) {
        return foundItem.id;
      } else {
        return null;
      }
    },
    checkOperationMode() {
      if (
        this.currentRoute.split("/").includes("edit") &&
        this.operationMode !== "update"
      ) {
        // if url has 'edit' keyword, set operation to edit
        this.$store.dispatch(Actions.CHANGE_OPERATION_MODE, {
          operation: "update"
        });
      } else if (
        this.currentRoute.split("/").includes("create") &&
        this.operationMode !== "create"
      ) {
        // if url has 'create' keyword, set operation to create
        this.$store.dispatch(Actions.CHANGE_OPERATION_MODE, {
          operation: "create"
        });
      }
    }
  }
};
</script>
